<template>
    <SidePanel
        :visible="messengerStore.isPanelVisible"
        :title="panelTitle"
        @close="closePanel"
    >
        <MessageThreadList
            :key="`messageThreadList-v${historyPanelVersion}`"
            v-if="messengerStore.activeTab == 'HISTORY'"
        ></MessageThreadList>
        <MessageThread
            v-else-if="messengerStore.activeTab == 'THREAD'"
            :thread-id="messengerStore.threadId"
        ></MessageThread>
        <NewMessageForm
            v-else-if="messengerStore.activeTab == 'NEW'"
            @thread-created="openThread"
        ></NewMessageForm>
        <MessageThreadUsers
            v-else-if="messengerStore.activeTab == 'THREAD_USERS'"
            :thread-id="messengerStore.threadUsersId"
        ></MessageThreadUsers>

        <template #footer>
            <hr />

            <div
                v-if="messengerStore.activeTab == 'HISTORY'"
                class="footer-row"
            >
                <button
                    class="btn btn-primary"
                    type="button"
                    v-on:click="markAllRead"
                >
                    Mark All As Read
                </button>

                <button
                    class="btn btn-light"
                    type="button"
                    v-on:click="messengerStore.openNew()"
                >
                    New Message
                </button>
            </div>

            <template
                v-else-if="
                    messengerStore.activeTab == 'THREAD' ||
                    messengerStore.activeTab == 'THREAD_USERS'
                "
            >
                <button
                    type="button"
                    class="btn btn-primary me-auto"
                    v-on:click="openHistory"
                >
                    <i class="fi fi-chevron-left"></i>
                    Back
                </button>
            </template>

            <template v-else-if="messengerStore.activeTab == 'NEW'">
                <button class="btn btn-primary" @click="openHistory">
                    <i class="fi fi-chevron-left"></i>
                    All Messages
                </button>
            </template>
        </template>
    </SidePanel>
</template>

<script>
import SidePanel from './SidePanel.vue';
import MessageThreadList from './messaging/MessageThreadList.vue';
import MessageThread from './messaging/MessageThread.vue';
import NewMessageForm from './messaging/NewMessageForm.vue';
import MessageThreadUsers from './messaging/MessageThreadUsers.vue';

import { useMessengerStore } from '@/stores/messenger';

export default {
    name: 'MessagingPanel',
    components: {
        SidePanel,
        MessageThreadList,
        MessageThread,
        NewMessageForm,
        MessageThreadUsers,
    },
    props: {},

    emits: ['close-panel'],

    data() {
        return {
            messengerStore: null, // useMessengerStore

            panelTitle: 'Messages',

            historyPanelVersion: 0,
        };
    },

    computed: {
        // computed property to remove deep watch on messengerStore
        isHistoryTabVisible() {
            return (
                this.messengerStore?.isPanelVisible &&
                this.messengerStore.activeTab == 'HISTORY'
            );
        },
    },

    methods: {
        markAllRead() {
            this.$postData('message-thread/toggle-all-read', {
                is_marked_read: true,
            }).then((response) => {
                if (response.success) {
                    this.historyPanelVersion++;
                }
            });
        },

        openHistory() {
            this.messengerStore.openHistory();
        },

        openThread(threadId) {
            this.messengerStore.openThread(threadId);
        },

        closePanel() {
            this.messengerStore.closePanel(); // Emit an event to update the 'visible' state from parent
            this.panelTitle = 'Messages';
        },
    },

    created() {
        this.messengerStore = useMessengerStore();
    },
};
</script>

<style scoped>
hr {
    margin-bottom: var(--space-3);
}

.footer-row {
    display: flex;
    justify-content: end;
    gap: var(--space-3);
}
</style>
